// ** React Imports
import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"

// ** Store & Actions
import { useSelector, useDispatch } from "react-redux"
import {
  handleMenuCollapsed,
  handleContentWidth,
  handleMenuHidden
} from "@store/layout"
import styles from './VerticalLayout.module.scss'
import { FiMenu } from "react-icons/fi";



// ** Third Party Components
import classnames from "classnames"
import { ArrowUp } from "react-feather"

import {
  Button,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText,
  Row,
  Col,
} from 'reactstrap';

// ** Configs
import themeConfig from "@configs/themeConfig"

// ** Custom Components

import Customizer from "@components/customizer"
import ScrollToTop from "@components/scrolltop"
import FooterComponent from "./components/footer"
import NavbarComponent from "./components/navbar"
import SidebarComponent from "./components/menu/vertical-menu"

// ** Custom Hooks
import { useRTL } from "@hooks/useRTL"
import { useSkin } from "@hooks/useSkin"
import { useLayout } from "@hooks/useLayout"
import { useNavbarType } from "@hooks/useNavbarType"
import { useFooterType } from "@hooks/useFooterType"
import { useNavbarColor } from "@hooks/useNavbarColor"

// ** Styles
import "@styles/base/core/menu/menu-types/vertical-menu.scss"
import "@styles/base/core/menu/menu-types/vertical-overlay-menu.scss"
import NewsLetter from "./components/newsletter/NewsLetter"
import LoginFooter from "./components/footer/LoginFooter"
import Header from "./components/Header/Header"
import SellerHeader from "./components/SellerHeader/SellerHeader"

const VerticalLayout = (props, args) => {
  // ** Props
  const { menu, navbar, footer, children, menuData } = props

  // ** Hooks
  const [isRtl, setIsRtl] = useRTL()
  const { skin, setSkin } = useSkin()
  const { navbarType, setNavbarType } = useNavbarType()
  const { footerType, setFooterType } = useFooterType()
  const { navbarColor, setNavbarColor } = useNavbarColor()
  const { layout, setLayout, setLastLayout } = useLayout()

  // ** States
  const [isMounted, setIsMounted] = useState(false)
  const [menuVisibility, setMenuVisibility] = useState(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  // ** Vars
  const dispatch = useDispatch()
  const layoutStore = useSelector((state) => state.layout)  

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  const isHidden = layoutStore.menuHidden
  const setIsHidden = () => dispatch(handleMenuHidden())

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ** Update Window Width
  const handleWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }



  // ** Vars
  const location = useLocation()
  const contentWidth = layoutStore.contentWidth
  const menuCollapsed = layoutStore.menuCollapsed

  // ** Toggles Menu Collapsed
  const setMenuCollapsed = (val) => dispatch(handleMenuCollapsed(val))

  // ** Handles Content Width
  const setContentWidth = (val) => dispatch(handleContentWidth(val))

  //** This function will detect the Route Change and will hide the menu on menu item click
  useEffect(() => {
    if (menuVisibility && windowWidth < 1200) {
      setMenuVisibility(false)
    }
  }, [location])

  //** Sets Window Size & Layout Props
  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener("resize", handleWindowWidth)
    }
  }, [windowWidth])

  //** ComponentDidMount
  useEffect(() => {
    setIsMounted(true)
    return () => setIsMounted(false)
  }, [])

  useEffect(() => {
    if (isHidden) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isHidden]);

  // ** Vars
  const footerClasses = {
    static: "footer-static",
    sticky: "footer-fixed",
    hidden: "footer-hidden"
  }

  const navbarWrapperClasses = {
    floating: "navbar-floating",
    sticky: "navbar-sticky",
    static: "navbar-static",
    hidden: "navbar-hidden"
  }

  const navbarClasses = {
    floating:
      contentWidth === "boxed" ? "floating-nav container-xxl" : "floating-nav",
    sticky: "fixed-top",
    static: "navbar-static-top",
    hidden: "d-none"
  }

  const bgColorCondition =
    navbarColor !== "" && navbarColor !== "light" && navbarColor !== "white"

  if (!isMounted) {
    return null
  }


  // Define the nav items and dropdown items in an array
  const navItems = [
    {
      title: 'Home',
      dropdownItems: ['Flash Sale', 'Categories', 'Top Rated Choices', 'Promotion']
    },
    {
      title: 'Features',
      dropdownItems: ['Blogs', 'Social Media Links', 'Testimonials', 'Partnerships']
    },
    {
      title: 'Offers',
      dropdownItems: ['Flash Sale', 'Categories']
    },
    {
      title: 'Options',
      dropdownItems: ['Option 1', 'Option 2', 'Reset']
    }
  ];

  let userData = JSON.parse(localStorage.getItem('userData'));
  let backendRoles = userData?.roles?.map((item) => item.role);
  let role = localStorage.getItem('selectedRole');

  const commonRowStyles = {
    margin: 0,
    padding: 0,
  };

  return (
    <>
      <header>
        {(role === 'seller' || role === 'wholesaler' || role === 'admin' || role === 'affiliate') && backendRoles?.includes(role) ? <SellerHeader /> : <Header />}
      </header>

      <div
      // style={{ height: '100vh' }}
      // className={classnames(
      //   `wrapper vertical-layout ${
      //     navbarWrapperClasses[navbarType] || "navbar-floating"
      //   } ${footerClasses[footerType] || "footer-static"}`,
      //   {
      //     // Modern Menu
      //     "vertical-menu-modern": windowWidth >= 1200,
      //     "menu-collapsed": menuCollapsed && windowWidth >= 1200,
      //     "menu-expanded": !menuCollapsed && windowWidth > 1200,

      //     // Overlay Menu
      //     "vertical-overlay-menu": windowWidth < 1200,
      //     "menu-hide": !menuVisibility && windowWidth < 1200,
      //     "menu-open": menuVisibility && windowWidth < 1200
      //   }
      // )}
      // {...(isHidden ? { "data-col": "1-column" } : {})}
      >
        {/* {!isHidden ? (
            <SidebarComponent
              skin={skin}
              menu={menu}
              menuData={menuData}
              menuCollapsed={menuCollapsed}
              menuVisibility={menuVisibility}
              setMenuCollapsed={setMenuCollapsed}
              setMenuVisibility={setMenuVisibility}
            />
          ) : null} */}

        {/* <Navbar
            expand="lg"
            container={false}
            light={skin !== "dark"}
            dark={skin === "dark" || bgColorCondition}
            color={bgColorCondition ? navbarColor : undefined}
            className={classnames(
              `header-navbar navbar align-items-center ${
                navbarClasses[navbarType] || "floating-nav"
              } navbar-shadow`
            )}
          >
            <div className="navbar-container d-flex content">
              {navbar ? (
                navbar({ skin, setSkin, setMenuVisibility })
              ) : (
                <NavbarComponent
                  setMenuVisibility={setMenuVisibility}
                  skin={skin}
                  setSkin={setSkin}
                />
              )}
            </div>
          </Navbar> */}
        <Row
          // className="m-0 p-0" 
          style={{
            ...commonRowStyles,
            ...((role === 'seller' || role === 'wholesaler' || role === 'admin' || role === 'affiliate') && backendRoles?.includes(role) && { marginTop: '71px' }),
          }}
        >
          {/* {isOpen && (<div style={{ background: 'black', position: 'absolute', inset: 0 }}></div>)} */}

          <Col xxl='2' xl='3' lg='3' md='4' sm='0' className={`p-0 ${styles.leftCol}`} style={{ background: '#1A2425' }}>
            {/* {!isHidden ? ( */}
            <SidebarComponent
              skin={skin}
              menu={menu}
              menuData={menuData}
              menuCollapsed={menuCollapsed}
              menuVisibility={menuVisibility}
              setMenuCollapsed={setMenuCollapsed}
              setMenuVisibility={setMenuVisibility}
              isMobile={isMobile}
            />
            {/* ) : null} */}

          </Col>
          <Col xxl='10' xl='9' lg='9' md='8' sm='12' className="p-0" style={{ /* height: 'calc(100vh - 56px)', overflowY:'auto', */  height: '100%' }}>
            {isMobile && <div className={`bg-black text-white d-inline-block ${styles.btn}`}><FiMenu size={24} onClick={setIsHidden} /></div>}
            {children}
          </Col>
        </Row>

        {/* Vertical Nav Menu Overlay */}
        <div
          className={classnames("sidenav-overlay", {
            show: isHidden
          })}
          onClick={setIsHidden}
        ></div>

        {/* {themeConfig.layout.customizer === true ? (
          <Customizer
            skin={skin}
            isRtl={isRtl}
            layout={layout}
            setSkin={setSkin}
            setIsRtl={setIsRtl}
            isHidden={isHidden}
            setLayout={setLayout}
            footerType={footerType}
            navbarType={navbarType}
            setIsHidden={setIsHidden}
            themeConfig={themeConfig}
            navbarColor={navbarColor}
            contentWidth={contentWidth}
            setFooterType={setFooterType}
            setNavbarType={setNavbarType}
            setLastLayout={setLastLayout}
            menuCollapsed={menuCollapsed}
            setNavbarColor={setNavbarColor}
            setContentWidth={setContentWidth}
            setMenuCollapsed={setMenuCollapsed}
          />
        ) : null} */}
        {/* <footer
          className={classnames(
            `footer footer-light ${footerClasses[footerType] || "footer-static"}`,
            {
              "d-none": footerType === "hidden"
            }
          )}
        >
          {footer ? (
            footer
          ) : (
            <FooterComponent
              footerType={footerType}
              footerClasses={footerClasses}
            />
          )}
        </footer> */}

        {/* {themeConfig.layout.scrollTop === true ? (
          <div className="scroll-to-top">
            <ScrollToTop showOffset={300} className="scroll-top d-block">
              <Button className="btn-icon" color="primary">
                <ArrowUp size={14} />
              </Button>
            </ScrollToTop>
          </div>
        ) : null} */}
      </div>
    </>
  )
}

export default VerticalLayout;